import * as reactBeautifulDnd from 'react-beautiful-dnd';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { createMuiTheme, makeStyles, Typography, useTheme, Box, ThemeProvider, Grid, List, useMediaQuery, TextField, ListItem, ListItemText, Grow, ListItemIcon, Tooltip, IconButton, Divider, Paper, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, CircularProgress, Accordion, AccordionSummary, AccordionDetails, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Dialog, Slide, DialogContent, DialogTitle, Chip } from '@material-ui/core';
import React, { createElement, Fragment, useState, useEffect, useMemo, useRef, cloneElement } from 'react';
import clsx from 'clsx';
import ErrorIcon from '@material-ui/icons/ErrorOutlineOutlined';
import WarningIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import SuccessIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import { withStyles, createStyles, makeStyles as makeStyles$1, useTheme as useTheme$1 } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { CheckCircle, RadioButtonUnchecked, DeleteOutlined, ArrowForwardIos, ExpandMore, Star, Delete, ChevronRight } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid$1 from '@material-ui/core/Grid';

var reExports = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), reactBeautifulDnd));

var paletteOptions = {
    primary: {
        main: "#BFCCBF",
        dark: "#ACB8AC",
        light: '#DFE6DF',
    },
    secondary: {
        light: "#FAEFE5",
        main: "#FBCFB1",
        dark: "#ECC5AA",
    },
    text: {
        primary: "#191919",
        secondary: "#4C4C4C",
        disabled: "#808080",
        hint: '#808080',
    },
    success: {
        main: "#8AA78A",
    },
    warning: {
        main: "#E4C05D",
    },
    error: {
        main: "#C05757",
    },
    grey: {
        50: "#fafafa",
        100: "#f2f2f2",
        200: "#e0e0e0",
    },
};
var typographyOptions = {
    fontFamily: '"Apercu", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontSize: 17,
    htmlFontSize: 17,
    allVariants: {
        fontWeight: 400,
    },
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h1: {
        fontSize: '3rem',
        '@media (max-width:768px)': {
            fontSize: '2rem',
        },
    },
    h2: {
        fontSize: '2.5rem',
        '@media (max-width:768px)': {
            fontSize: '2rem',
        },
    },
    h3: {
        fontSize: '2rem',
        '@media (max-width:768px)': {
            fontSize: '1.5rem',
        },
    },
    h4: {
        fontSize: '1.5rem',
        '@media (max-width:768px)': {
            fontSize: '1.25rem',
        },
    },
    h5: {
        fontSize: '1.25rem',
        '@media (max-width:768px)': {
            fontSize: '1rem',
        },
    },
    h6: {
        fontSize: '1rem',
        '@media (max-width:768px)': {
            fontSize: '0.9rem',
        },
    },
    subtitle1: {
        fontSize: '1rem',
        lineHeight: 1.2,
        fontWeight: 500,
        '@media (max-width:768px)': {
            fontSize: '0.9rem',
        },
    },
    body1: {
        fontSize: '1rem',
    },
    body2: {
        fontSize: '0.85rem',
    },
    overline: {
        fontSize: '0.75rem',
        textTransform: 'none',
    },
    caption: {
        fontSize: '0.65rem',
    },
};
var overridesOptions = {
    MuiCssBaseline: {
        '@global': {
            html: {
                WebkitFontSmoothing: 'auto',
            },
        },
    },
    MuiButton: {
        root: {
            transition: 'ease-in all 0.15s',
            '&:hover': {
                transform: 'translate(0px, -2px)',
            },
        },
        contained: {
            backgroundColor: '#f2f2f2',
            '&:hover': {
                backgroundColor: '#e0e0e0',
            },
        },
        outlined: {
            border: '1px solid #191919',
        },
    },
    MuiSvgIcon: {
        root: {
            color: '#4C4C4C',
        },
    },
    MuiExpansionPanel: {
        root: {
            margin: '0 !important',
            '&:before': {
                display: 'none',
            },
        },
    },
    MuiExpansionPanelSummary: {
        root: {
            minHeight: '48px!important',
        },
        content: {
            margin: '12px 0!important',
        },
    },
    MuiTextField: {
        root: {
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e0e0e0",
            },
            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc"
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#BFCCBF",
            },
        },
    },
};
var theme = createMuiTheme({
    palette: paletteOptions,
    typography: typographyOptions,
    overrides: overridesOptions,
});

var formatNumToUSD = function (num, withDollarSign) {
    return "$" + (num / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

var parseExperienceVersion = function (versionString, dontThrowOnInvalid) {
    if (!versionString) {
        return [1, 0];
    }
    var majorMinor = versionString.split(".");
    if (majorMinor.length !== 2) {
        if (dontThrowOnInvalid) {
            console.error("Invalid Version String: " + versionString);
            return [1, 0];
        }
        throw new Error("Invalid Version String: " + versionString);
    }
    try {
        return majorMinor.map(function (stringedInt) {
            var parsed = parseInt(stringedInt, 10);
            if (isNaN(parsed)) {
                throw new Error("version component value is NaN: " + stringedInt);
            }
            return parsed;
        });
    }
    catch (error) {
        if (dontThrowOnInvalid) {
            console.error(error);
            return [1, 0];
        }
        throw error;
    }
};

var passesExperienceVersionCheck = function (experienceVersion, gate, returnFalseDontThrow) {
    if (returnFalseDontThrow === void 0) { returnFalseDontThrow = false; }
    try {
        var _a = parseExperienceVersion(experienceVersion), checkMajor = _a[0], checkMinor = _a[1];
        var _b = parseExperienceVersion(gate), gateMajor = _b[0], gateMinor = _b[1];
        return checkMajor >= gateMajor && checkMinor >= gateMinor;
    }
    catch (err) {
        if (returnFalseDontThrow) {
            console.error(err);
            return false;
        }
        throw err;
    }
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var useStyles = makeStyles(function (theme) { return ({
    root: function (props) { return (__assign(__assign(__assign({}, (props.type === "uppercase"
        ? {
            textTransform: 'uppercase',
            letterSpacing: '2px',
            fontWeight: 500,
        }
        : {})), (props.type === "serif"
        ? {
            fontFamily: 'Domaine Display, serif',
        }
        : {})), (props.type === "mono"
        ? {
            fontFamily: '"Roboto Mono", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            textTransform: 'uppercase',
            letterSpacing: '1px',
        }
        : {}))); },
}); });
var YZTypography = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles({
        type: props.type || {},
    });
    return (React.createElement(Typography, __assign({}, props, { classes: {
            root: classes.root,
        } }), children));
});

var useStyles$1 = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        alignItems: "center",
        padding: "6px 16px",
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.43,
        borderRadius: "4px",
        letterSpacing: "0.01071em",
    },
    icon: {
        display: "flex",
        opacity: 0.9,
        padding: "7px 0",
        fontSize: "22px",
        marginRight: "12px",
    },
    message: {
        padding: "8px, 0",
    },
    error: { color: "rgb(97, 26, 21)", backgroundColor: "rgb(248, 238, 238)" },
    warning: { color: "rgb(102, 60, 0)", backgroundColor: "rgb(252, 248, 238)" },
    info: { color: "rgb(13, 60, 97)", backgroundColor: "rgb(232, 244, 253)" },
    success: { color: "rgb(30, 70, 32)", backgroundColor: "rgb(237, 247, 237)" },
}); });
var YZAlert = React.forwardRef(function (_a, ref) {
    var children = _a.children, typographyProps = _a.typographyProps, slim = _a.slim, inheritFont = _a.inheritFont, style = _a.style, severity = _a.severity, props = __rest(_a, ["children", "typographyProps", "slim", "inheritFont", "style", "severity"]);
    var theme = useTheme();
    var classes = useStyles$1({});
    var icon = getIcon(severity);
    return (React.createElement("div", { className: clsx(classes.root, classes[severity]), style: style },
        React.createElement("div", { className: classes.icon }, icon),
        renderChildren(children, typographyProps, slim, inheritFont)));
});
function renderChildren(children, typographyProps, slim, inheritFont) {
    if (typeof children === "string") {
        return (React.createElement(YZTypography, __assign({}, typographyProps, { type: inheritFont ? undefined : "mono", style: __assign({ padding: "7.5px 12px", fontSize: slim ? "12.6px" : "14.4px" }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.style) }), children));
    }
    return children || null;
}
function getIcon(severity) {
    if (severity === "error") {
        return React.createElement(ErrorIcon, { fontSize: "small" });
    }
    if (severity === "warning") {
        return React.createElement(WarningIcon, { fontSize: "small" });
    }
    if (severity === "info") {
        return React.createElement(InfoIcon, { fontSize: "small" });
    }
    if (severity === "success") {
        return React.createElement(SuccessIcon, { fontSize: "small" });
    }
}

var useStyles$2 = makeStyles(function (theme) { return ({
    root: function (props) { return (__assign(__assign({}, (props.variant === "contained"
        ? {
            border: "solid 1px " + (props.color === "primary"
                ? theme.palette.primary.dark
                : theme.palette.secondary.dark),
        }
        : {})), { borderRadius: 4 })); },
}); });
var YZButton = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, typographyProps = _a.typographyProps, slim = _a.slim, inheritFont = _a.inheritFont, style = _a.style, props = __rest(_a, ["children", "typographyProps", "slim", "inheritFont", "style"]);
    var theme = useTheme();
    var classes = useStyles$2({
        color: (_b = props.color) !== null && _b !== void 0 ? _b : "default",
        variant: props.variant || "",
    });
    return (React.createElement(Button, __assign({ ref: ref, variant: "contained", disableElevation: true }, props, { style: slim ? __assign({ padding: theme.spacing(0.5) }, style) : style ? __assign({}, style) : undefined, classes: {
            root: classes.root,
        } }), renderChildren$1(children, typographyProps, slim, inheritFont)));
});
function renderChildren$1(children, typographyProps, slim, inheritFont) {
    if (typeof children === "string") {
        return (React.createElement(YZTypography, __assign({}, typographyProps, { type: inheritFont ? undefined : "mono", style: __assign({ padding: "7.5px 12px", fontSize: slim ? "12.6px" : '14.4px' }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.style) }), children));
    }
    return children || null;
}

var useStyles$3 = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2, 3),
        borderRadius: 4,
        border: '0',
        transition: "background-color 250ms",
        pointerEvents: "all",
        backgroundColor: theme.palette.grey[100],
        cursor: "pointer",
        outline: "none",
        "&:active": {
            outline: "0",
            color: "black",
            transition: "translate 250ms",
            transform: "translate(0, -2px)",
        },
    },
    toggled: {
        backgroundColor: theme.palette.primary.main + " !important",
    },
    toggledSecondary: {
        backgroundColor: theme.palette.secondary.main + " !important",
    },
    iconContainer: {
        '& > svg': {
            color: theme.palette.text.secondary,
        }
    },
    iconContainerActive: {
        '& > svg': {
            color: theme.palette.text.primary,
        }
    },
}); });
var ToggleSelectButton = function (props) {
    var _a;
    var classes = useStyles$3();
    var iconClass = props.toggleState ? classes.iconContainerActive : classes.iconContainer;
    return (createElement(Box, __assign({ component: "button", m: 1, width: props.width || "100%" }, props.containerProps, { onClick: function () { return props.onChange(props.value); }, className: classnames(classes.root, props.toggleState ? getCorrectToggledClass() : void 0, (_a = props.containerProps) === null || _a === void 0 ? void 0 : _a.className) }),
        props.icon && (createElement(Box, { mb: 1, className: iconClass }, props.icon)),
        createElement(YZTypography, { align: "center", noWrap: true, type: props.inheritFont ? undefined : "mono", variant: props.inheritFont ? undefined : "body2", style: props.toggleState ? { color: theme.palette.text.primary } : { color: theme.palette.text.secondary } }, props.children)));
    function getCorrectToggledClass() {
        return props.colorSecondary ? classes.toggledSecondary : classes.toggled;
    }
};

var YZThemeProvider = function (props) {
    return React.createElement(ThemeProvider, { theme: theme }, props.children);
};

var CenterContentsForStorybook = function (props) {
    return (React.createElement(Box, { height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }, props.children));
};

var useStyles$4 = makeStyles(function (theme) {
    var _a;
    return (_a = {},
        _a[theme.breakpoints.down("sm")] = {
            container: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            },
        },
        _a);
});
var MultipleImageSelectItemContainer = function (_a) {
    var children = _a.children, maxWidth = _a.maxWidth;
    var classes = useStyles$4();
    return (React.createElement(Grid, { container: true, spacing: 3, style: { maxWidth: maxWidth }, className: classes.container }, children));
};

function isOverOrUnderBudget(currentTotal, minBudget, maxBudget, selectedAssignment) {
    // __free_mode__ can occur inside Sketchup plugin. Happens
    // when the designer opts to not select an assignment.
    if (selectedAssignment === "__free_mode__") {
        return 0;
    }
    var amountLeftUntilBudgetMin = minBudget - currentTotal;
    var amountLeftUntilBudgetMax = maxBudget - currentTotal;
    var isBelowBudgetMin = amountLeftUntilBudgetMin > 0;
    if (isBelowBudgetMin) {
        return -1;
    }
    var isOverBudget = amountLeftUntilBudgetMax < 0;
    if (isOverBudget) {
        return 1;
    }
    return 0;
}
var LinearProgressStyles = function (color) {
    return withStyles(function (theme) {
        return createStyles({
            root: {
                marginTop: "12px",
                height: 15,
                borderRadius: 5,
            },
            colorPrimary: {
                backgroundColor: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
            },
            bar: {
                borderRadius: 5,
                backgroundColor: color,
            },
        });
    });
};
var BorderLinearProgress = LinearProgressStyles("#9BBDA3")(LinearProgress);
var GoodRangeBorderLinearProgress = LinearProgressStyles("#9BBDA3")(LinearProgress);
var ErrorBorderLinearProgress = LinearProgressStyles("red")(LinearProgress);
var useStyles$5 = makeStyles$1({
    root: {
        flexGrow: 1,
    },
    underBudget: {
        color: "#1a90ff",
    },
    overBudget: {
        color: "red",
    },
    inBudget: {
        color: "green",
    },
    greyText: {
        color: "#808080",
        width: "7rem",
    },
    headerLine: {
        display: "flex",
        marginTop: "0.5rem",
        fontSize: "17px",
    },
    priceLandmark: {
        fontSize: "12px",
    },
    priceLandmarks: {
        display: "flex",
        justifyContent: "space-between",
    },
});
function CostVersusBudgetInfo(props) {
    var overOrUnderBudgetNumber = isOverOrUnderBudget(props.currentTotal, props.minBudget, props.maxBudget);
    var amountLeftUntilBudgetMin = function () {
        return props.minBudget - props.currentTotal;
    };
    var amountLeftUntilBudgetMax = function () {
        return props.maxBudget - props.currentTotal;
    };
    var percentageUntilBudgetMin = function () {
        return (1 - amountLeftUntilBudgetMin() / props.minBudget) * 100;
    };
    var percentageUntilBudgetMax = function () {
        return (1 - amountLeftUntilBudgetMax() / props.maxBudget) * 100;
    };
    var isBelowBudgetMin = function () { return overOrUnderBudgetNumber === -1; };
    var isOverBudget = function () { return overOrUnderBudgetNumber === 1; };
    var progressBarColor = function () {
        if (isBelowBudgetMin()) {
            return "#1a90ff";
        }
        if (isOverBudget()) {
            return "red";
        }
        return "green";
    };
    var classes = useStyles$5({ color: progressBarColor() });
    var Title = function () { return (React.createElement(YZTypography, { variant: "h3", type: "serif" }, "Cost Tracker")); };
    var SpendAndBudget = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.headerLine },
            React.createElement(YZTypography, { variant: "body1", type: "serif", className: classes.greyText }, "Current Spend"),
            React.createElement(YZTypography, { variant: "body1", type: "serif" }, formatNumToUSD(props.currentTotal))),
        React.createElement("div", { className: classes.headerLine },
            React.createElement(YZTypography, { variant: "body1", type: "serif", className: classes.greyText }, "Client Budget"),
            React.createElement(YZTypography, { variant: "body1", type: "serif" }, formatNumToUSD(props.budget))),
        React.createElement("div", { className: classes.headerLine },
            React.createElement(YZTypography, { variant: "body1", type: "serif", className: classes.greyText }, "Acceptable Range"),
            React.createElement(YZTypography, { variant: "body1", type: "serif" },
                formatNumToUSD(props.minBudget),
                " - ",
                formatNumToUSD(props.maxBudget))))); };
    var PriceLandmarks = function (_a) {
        var priceRight = _a.priceRight;
        return (React.createElement("div", { className: classes.priceLandmarks },
            React.createElement(YZTypography, { className: classes.priceLandmark, type: "serif" }, "$0"),
            React.createElement(YZTypography, { className: classes.priceLandmark, type: "serif" }, formatNumToUSD(priceRight))));
    };
    if (isBelowBudgetMin()) {
        return (React.createElement("div", { className: classes.root },
            React.createElement(Title, null),
            React.createElement(SpendAndBudget, null),
            React.createElement(BorderLinearProgress, { variant: "determinate", value: percentageUntilBudgetMin() }),
            React.createElement(PriceLandmarks, { priceRight: props.minBudget }),
            React.createElement("br", null),
            React.createElement(YZAlert, { severity: "warning" },
                formatNumToUSD(amountLeftUntilBudgetMin()),
                " to acceptable budget min.")));
    }
    if (isOverBudget()) {
        return (React.createElement("div", { className: classes.root },
            React.createElement(Title, null),
            React.createElement(SpendAndBudget, null),
            React.createElement(ErrorBorderLinearProgress, { variant: "determinate", value: 100 }),
            React.createElement(PriceLandmarks, { priceRight: props.maxBudget }),
            React.createElement("br", null),
            React.createElement(YZAlert, { severity: "error" },
                formatNumToUSD(Math.abs(amountLeftUntilBudgetMax())),
                " way over budget!")));
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement(Title, null),
        React.createElement(SpendAndBudget, null),
        React.createElement(GoodRangeBorderLinearProgress, { variant: "determinate", value: percentageUntilBudgetMax() }),
        React.createElement(PriceLandmarks, { priceRight: props.maxBudget }),
        React.createElement("br", null),
        React.createElement(YZAlert, { severity: "info" },
            formatNumToUSD(amountLeftUntilBudgetMax()),
            " to budget max.")));
}

var BudgetCategoryChecklistContainer = function (_a) {
    var category = _a.category, children = _a.children;
    return (React.createElement(Box, { width: "100%", p: 1, pl: 0, maxWidth: "1080px" },
        React.createElement(YZTypography, { type: "serif", variant: "h6" }, category.name),
        category.description && (React.createElement(YZTypography, { variant: "body2", color: "textSecondary" }, category.description)),
        React.createElement(List, null, children)));
};

var useStyles$6 = makeStyles(function (theme) { return ({
    verticalContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '300px',
    },
    horizontalContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        maxWidth: '1080px',
        gap: '0 16px',
    },
}); });
var ToggleSelectWrapper = function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? "vertical" : _b, props = __rest(_a, ["orientation"]);
    var smDown = useMediaQuery(function (theme) {
        return theme.breakpoints.down("sm");
    });
    var classes = useStyles$6();
    return (createElement(Box, __assign({}, props.containerProps, { display: "flex", flexDirection: "column", alignItems: "center" }),
        createElement(Box, { width: "100%", display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }, props.prompt),
        createElement(Box, { width: "100%", className: horizontalRenderCheck() ? classes.horizontalContainer : classes.verticalContainer, p: 1 }, renderOpts())));
    function renderOpts() {
        return (createElement(Fragment, null, props.options.map(function (o) { return (createElement(ToggleSelectButton, { key: o.value, value: o.value, toggleState: detectToggled(o.value), onChange: handleClick, children: o.label, icon: o.icon, colorSecondary: props.colorSecondary, inheritFont: props.inheritFont })); })));
    }
    function handleClick(val) {
        return props.onSelected(val);
    }
    function horizontalRenderCheck() {
        if (orientation === "vertical") {
            return false;
        }
        if (smDown) {
            return false;
        }
        return true;
    }
    function detectToggled(val) {
        if (props.selectVariant === "MULTIPLE") {
            return props.selected.includes(val);
        }
        else {
            return props.selected === val;
        }
    }
};

var useStyles$7 = makeStyles(function (theme) { return ({
    root: {
        width: "100%",
        maxWidth: "700px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}); });
var LabeledTextArea = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, labelVariant = _a.labelVariant;
    var classes = useStyles$7();
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Box, { alignSelf: "flex-start", pb: 4 }, renderLabel()),
        React.createElement(Box, { width: "90%", minWidth: "320px" },
            React.createElement(TextField, { fullWidth: true, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0, variant: "outlined", multiline: true, type: "textfield", rows: 10, rowsMax: 15, value: value, onChange: function (e) { return onChange(e.target.value); } }))));
    function renderLabel() {
        if (typeof label === "string") {
            return React.createElement(Typography, { variant: labelVariant !== null && labelVariant !== void 0 ? labelVariant : "h6" }, label);
        }
        else {
            return label;
        }
    }
};

// network uri -> local blob uri
var loadedImageUris = {};
// TODO: Add parameter to specify options for fetch
// TODO: add way for caller to be notified of and handle errors
var useLoadImageWithThumbnail = function (imageUri, thumbnailUri) {
    var _a;
    var _b = useState(null), blobImageUrl = _b[0], setBlobImageUrl = _b[1];
    useEffect(handleImageUriChange, [imageUri]);
    return [(_a = blobImageUrl !== null && blobImageUrl !== void 0 ? blobImageUrl : thumbnailUri) !== null && _a !== void 0 ? _a : null, !blobImageUrl];
    function handleImageUriChange() {
        void (function () {
            return __awaiter(this, void 0, void 0, function () {
                var headers, resp, blob, uri;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (loadedImageUris[imageUri]) {
                                return [2 /*return*/, setBlobImageUrl(loadedImageUris[imageUri])];
                            }
                            headers = new Headers();
                            headers.set("Content-Type", "text/plain");
                            return [4 /*yield*/, fetch(imageUri, {
                                    method: "GET",
                                    mode: "cors",
                                    headers: headers,
                                })];
                        case 1:
                            resp = _a.sent();
                            if (!resp.ok) {
                                return [2 /*return*/, console.error("request failed: " + resp.status + " - " + resp.statusText)];
                            }
                            return [4 /*yield*/, resp.blob()];
                        case 2:
                            blob = _a.sent();
                            uri = URL.createObjectURL(blob);
                            setBlobImageUrl(uri);
                            return [2 /*return*/];
                    }
                });
            });
        })();
    }
};

var useStyles$8 = makeStyles(function (theme) {
    var _a;
    return ({
        root: function (withLabel) {
            var _a;
            return (_a = {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    boxShadow: "0 0 5px -2px #bfbfbf",
                    padding: theme.spacing(3)
                },
                _a[theme.breakpoints.up("sm")] = {
                    "&:hover": {
                        boxShadow: "0 0 10px 0 #bfbfbf",
                        transition: "box-shadow 150ms",
                    },
                },
                _a[theme.breakpoints.down("sm")] = {
                    minWidth: "250px",
                },
                _a);
        },
        selected: {
            border: "1px solid black",
            boxShadow: "0 0 10px -15px #bfbfbf",
            zIndex: 17,
            padding: "15px",
        },
        imageDiv: {
            height: "150px",
            width: "90%",
            minHeight: "130px",
            minWidth: "130px",
            backgroundPosition: "center",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
        },
        copyContainer: (_a = {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "1rem"
            },
            _a[theme.breakpoints.down("sm")] = {
                width: "200px",
                maxWidth: "200px",
                paddingLeft: "1rem",
                paddingTop: 0,
            },
            _a),
    });
});
var LabeledImageSelectItem = function (_a) {
    var itemId = _a.itemId, imageUri = _a.imageUri, thumbnailUri = _a.thumbnailUri, selected = _a.selected, label = _a.label, labelVariant = _a.labelVariant, onSelect = _a.onSelect;
    var classes = useStyles$8(!!label);
    var smDown = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _imageUri = useLoadImageWithThumbnail(imageUri, thumbnailUri)[0];
    return (React.createElement(Grid, { item: true, md: 4 },
        React.createElement(Box, { className: classnames(classes.root, selected ? classes.selected : void 0), onClick: function () { return onSelect(itemId); }, key: itemId },
            React.createElement("div", { className: classes.imageDiv, style: { backgroundImage: "url(" + _imageUri + ")" } }),
            label && React.createElement(Box, { className: classes.copyContainer }, renderLabel()))));
    function renderLabel() {
        if (typeof label === "string") {
            return (React.createElement(Typography, { align: smDown ? void 0 : "center", variant: labelVariant !== null && labelVariant !== void 0 ? labelVariant : "h6" }, label));
        }
        else {
            return label;
        }
    }
};

var PriceOptionSelectItem = function (_a) {
    var onSelect = _a.onSelect, itemId = _a.itemId, imageUri = _a.imageUri, selected = _a.selected, description = _a.description, lowPrice = _a.lowPrice, highPrice = _a.highPrice;
    var smDown = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    return (React.createElement(LabeledImageSelectItem, { onSelect: onSelect, itemId: itemId, imageUri: imageUri, selected: selected, label: React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "h6", align: smDown ? void 0 : "center" },
                formatNumToUSD(lowPrice),
                " - ",
                formatNumToUSD(highPrice)),
            React.createElement(Typography, null, description)) }));
};

var StyleSelectItem = function (_a) {
    var onSelect = _a.onSelect, itemId = _a.itemId, imageUri = _a.imageUri, selected = _a.selected, name = _a.name;
    var smDown = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    return (React.createElement(LabeledImageSelectItem, { onSelect: onSelect, itemId: itemId, imageUri: imageUri, selected: selected, label: name ? React.createElement(Typography, { align: smDown ? void 0 : "center" }, name) : "" }));
};

var useStyles$9 = makeStyles(function (theme) { return ({
    listItem: {
        paddingTop: "4px",
        paddingBottom: "4px",
        cursor: "pointer",
    },
    listItemChecked: {
        background: theme.palette.primary.light,
    },
    listIcon: {
        fontSize: 18,
        color: theme.palette.grey[200],
        margin: theme.spacing(1),
    },
    listIconChecked: {
        fontSize: 18,
        color: theme.palette.primary.main,
        margin: theme.spacing(1),
    },
    checkbox: {
        height: "18px",
        width: "18px",
        border: "1.75px solid black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    checkIcon: {
        paddingLeft: "9px",
        paddingBottom: "9px",
    },
    checkIconColor: {
        color: theme.palette.primary.dark,
    },
    arrowIcon: {
        justifySelf: "flex-end",
        marginLeft: 8,
        fontSize: 16,
    },
    Divider: {
        backgroundColor: theme.palette.grey[200],
    },
    primaryTextWrapper: {
        minWidth: "110px",
        flex: 1,
    },
    secondaryTextWrapper: {
        minWidth: "70px",
    },
}); });
var BudgetCategoryChecklistItem = function (_a) {
    var onClick = _a.onClick, onRemoveClick = _a.onRemoveClick, name = _a.name, value = _a.value, checked = _a.checked, iconUri = _a.iconUri, containerProps = _a.containerProps, priceRange = _a.priceRange;
    var classes = useStyles$9();
    var smDown = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formattedPriceRange = useMemo(transformPriceObject, [
        priceRange === null || priceRange === void 0 ? void 0 : priceRange.lowPrice,
        priceRange === null || priceRange === void 0 ? void 0 : priceRange.highPrice,
    ]);
    return (React.createElement("div", __assign({}, containerProps, { key: name }),
        React.createElement(ListItem, { className: checked ? classes.listItemChecked : classes.listItem, onClick: function () { return onClick(value); } },
            React.createElement(Box, { display: "flex", alignItems: "center", width: "100%" },
                checked ? (React.createElement(CheckCircle, { className: classes.listIconChecked })) : (React.createElement(RadioButtonUnchecked, { className: classes.listIcon })),
                React.createElement(ListItemText, { primary: name, classes: { root: classes.primaryTextWrapper } }),
                !!iconUri && !smDown && (React.createElement(Grow, { in: checked, mountOnEnter: !checked, unmountOnExit: true },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Box, { maxHeight: "20px", height: "20px", pl: 0.5, pr: 0 },
                            React.createElement("img", { src: iconUri, alt: "item icon", style: { height: "100%" } }))))),
                React.createElement(Box, { pr: 2 }, renderPriceRange()),
                !!onRemoveClick && !!checked && (React.createElement(Tooltip, { title: "Remove item" },
                    React.createElement(IconButton, { size: "small", onClick: function () { return onRemoveClick(value); } },
                        React.createElement(DeleteOutlined, { style: { fontSize: 20 } })))),
                React.createElement(ArrowForwardIos, { fontSize: "small", className: classes.arrowIcon }))),
        React.createElement(Divider, { classes: { root: classes.Divider } })));
    function renderPriceRange() {
        if (!formattedPriceRange) {
            return null;
        }
        return (React.createElement(Typography, { variant: smDown ? "body2" : "body1", align: "right", color: "textSecondary", classes: { root: classes.secondaryTextWrapper } },
            formattedPriceRange[0],
            " - ",
            formattedPriceRange[1]));
    }
    function transformPriceObject() {
        if (priceRange) {
            return [
                formatNumToUSD(priceRange.lowPrice),
                formatNumToUSD(priceRange.highPrice),
            ];
        }
        return null;
    }
};

var useStyles$a = makeStyles$1(function (theme) { return ({
    root: {
        flexGrow: 1,
    },
    elements: {
        padding: theme.spacing(2)
    },
    paper: {
        alignItems: "center",
        display: "flex",
        padding: theme.spacing(2),
        marginBottom: '2px'
    },
    paperRight: {
        display: "flex"
    },
    icon: {
        marginRight: theme.spacing(2)
    },
    text: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between"
    },
    greyText: {
        color: "#808080"
    }
}); });
function ClientWishListProgressTracker(props) {
    var classes = useStyles$a();
    var Title = function () { return (React.createElement(YZTypography, { variant: "h3", type: "serif" }, "Elements")); };
    var RangeComponent = function (_props) {
        if (typeof _props.budgetMin !== 'number' || typeof _props.budgetMax !== "number") {
            return null;
        }
        if (typeof _props.price === "number") {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.paperRight },
                React.createElement(Typography, { className: classes.greyText }, "Est. Range"),
                "\u00A0 \u00A0",
                React.createElement(Typography, null,
                    formatNumToUSD(_props.budgetMin),
                    " - ",
                    formatNumToUSD(_props.budgetMax)))));
    };
    var PriceComponent = function (_props) {
        if (typeof _props.price !== 'number') {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.paperRight },
                React.createElement(Typography, { className: classes.greyText }, "Price"),
                "\u00A0 \u00A0",
                React.createElement(Typography, null, formatNumToUSD(_props.price)))));
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(Title, null),
        React.createElement("div", { className: classes.elements },
            props.elements.map(function (element) { return (React.createElement(Paper, { className: classes.paper, elevation: 3 },
                React.createElement(CheckCircleIcon, { className: classes.icon, style: { color: element.checked ? "#8AA78A" : "#BDBDBD" } }),
                React.createElement("div", { className: classes.text },
                    React.createElement(Typography, null, element.name),
                    React.createElement(RangeComponent, __assign({}, element)),
                    React.createElement(PriceComponent, __assign({}, element))))); }),
            !props.elements.length ? (React.createElement(Typography, null,
                React.createElement("em", null, "No elements to display."))) : null)));
}

var useStyles$b = makeStyles(function (theme) { return ({
    iconDiv: {
        height: "40px",
        width: "40px",
        minHeight: "40px",
        minWidth: "40px",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        backgroundColor: "#979696",
    },
}); });
var IconHeader = function (_a) {
    var iconUri = _a.iconUri, title = _a.title, currentStep = _a.currentStep, steps = _a.steps;
    var classes = useStyles$b();
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", alignItems: "center", width: "100%" },
            iconUri && (React.createElement("div", { className: classes.iconDiv, style: { backgroundImage: "url(" + iconUri } })),
            React.createElement(Box, { pl: 2, flex: "1" },
                React.createElement(YZTypography, { variant: "h4", type: "serif" }, title)),
            !(steps === void 0 || currentStep === void 0) && (React.createElement(Typography, { color: "textSecondary" },
                "Step ",
                currentStep,
                "/",
                steps)))));
};

/*
  useTriggerTimeout executes a handler funciton 'triggeredFunc' after a (ms) delay timeout.

  Returned object contains methods to start the trigger, abort the process, and a boolean
  property that specifies whether the timeout is currently ticking
*/
var useTriggerTimeout = function (triggeredFunc, timeout) {
    if (timeout === void 0) { timeout = 250; }
    var timeoutRef = useRef(null);
    var _a = useState(false), triggered = _a[0], setTriggered = _a[1];
    useEffect(autoAbortOnUnmount, []);
    useEffect(handleTriggeredChange, [triggered]);
    return useMemo(function () { return ({
        triggerTimeout: triggerTimeout,
        abortTimeout: abortTimeout,
        triggered: triggered,
    }); }, [triggered]);
    function handleTriggeredChange() {
        if (triggered && timeoutRef.current === null) {
            timeoutRef.current = setTimeout(triggeredFunc, timeout);
        }
        else if (!triggered && timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }
    function autoAbortOnUnmount() {
        return function () { return clearTimeout(timeoutRef.current); };
    }
    function triggerTimeout() {
        if (triggered) {
            throw new Error("Cannot trigger timeout already in motion");
        }
        setTriggered(true);
    }
    function abortTimeout() {
        setTriggered(false);
    }
};

var baseStyles = {
    userSelect: "none",
};
var DraggableItemWrapper = function (_a) {
    var containerStyles = _a.containerStyles, draggingStyles = _a.draggingStyles, Component = _a.Component, draggableProps = __rest(_a, ["containerStyles", "draggingStyles", "Component"]);
    return React.createElement(Draggable, __assign({}, draggableProps, { children: renderDraggableChild }));
    function renderDraggableChild(provided, snapshot) {
        var style = __assign(__assign(__assign({}, baseStyles), containerStyles), provided.draggableProps.style);
        if (snapshot.isDragging && draggingStyles) {
            style = __assign(__assign({}, draggingStyles), style);
        }
        return (React.createElement("div", __assign({ ref: provided.innerRef }, provided.dragHandleProps, provided.draggableProps, { style: style }), cloneElement(Component, {
            dragging: snapshot.isDragging,
            dropping: snapshot.isDropAnimating,
            style: __assign(__assign({}, Component.props.style), { userSelect: "none" }),
        })));
    }
};
DraggableItemWrapper.defaultProps = {
    containerStyles: {},
    draggingStyles: {},
};

var DEV = process.env.NODE_ENV === "development";
var KEY_ERROR_MESSAGE = "All elemnts passed as children to DroppableContainerWrapper must have unique keys";
var DroppableContainerWrapper = function (_a) {
    var children = _a.children, draggableProps = _a.draggableProps, Container = _a.Container, droppableProps = __rest(_a, ["children", "draggableProps", "Container"]);
    return React.createElement(Droppable, __assign({}, droppableProps), droppableChildfn);
    function renderItems(placeholder) {
        var items = children.map(function (child, i) {
            var _a, _b;
            if (!child.key) {
                if (DEV) {
                    throw new Error(KEY_ERROR_MESSAGE);
                }
                console.error(KEY_ERROR_MESSAGE);
            }
            return (React.createElement(DraggableItemWrapper, __assign({}, draggableProps, { draggableId: (_b = (_a = child.key) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "", key: child.key, Component: child, index: i })));
        });
        items.push(placeholder);
        return items;
    }
    function droppableChildfn(provided, snapshot) {
        return (React.createElement(React.Fragment, null, cloneElement(Container, __assign(__assign(__assign({}, provided.droppableProps), snapshot), { children: renderItems(provided.placeholder), style: __assign(__assign(__assign({}, Container.props.style), provided.droppableProps), { userSelect: "none" }), ref: provided.innerRef }))));
    }
};

var useStyles$c = makeStyles(function (theme) { return ({
    divider: {
        backgroundColor: theme.palette.grey[100],
    },
}); });
var ExpansionFAQ = function (_a) {
    var label = _a.label, labelProps = _a.labelProps, withBorder = _a.withBorder, contents = _a.contents, summaryProps = _a.summaryProps, descriptionProps = _a.descriptionProps, containerProps = _a.containerProps;
    var classes = useStyles$c();
    return (React.createElement(Box, __assign({}, containerProps, { width: (containerProps === null || containerProps === void 0 ? void 0 : containerProps.width) ? containerProps.width : "100%", border: withBorder
            ? (containerProps === null || containerProps === void 0 ? void 0 : containerProps.border) ? containerProps === null || containerProps === void 0 ? void 0 : containerProps.border : "1px solid " + theme.palette.grey[200]
            : void 0, p: (containerProps === null || containerProps === void 0 ? void 0 : containerProps.p) || (containerProps === null || containerProps === void 0 ? void 0 : containerProps.padding)
            ? containerProps.p || containerProps.padding
            : 0 }),
        React.createElement(Box, { pb: 2 }, renderLabel()),
        contents.map(function (item) { return (React.createElement(Fragment, { key: "exfax-item-" + item.title },
            React.createElement(ExpansionPanel, { elevation: 0, style: { backgroundColor: "inherit" } },
                React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMore, { style: { fontSize: '14px' } }) },
                    React.createElement(YZTypography, __assign({ variant: "subtitle1", style: { fontWeight: 500 } }, summaryProps), item.title)),
                React.createElement(ExpansionPanelDetails, null, renderDescription(item.description))),
            React.createElement(Divider, { className: classes.divider }))); })));
    function renderLabel() {
        if (!label)
            return React.createElement(React.Fragment, null);
        if (typeof label === "string") {
            return (React.createElement(YZTypography, __assign({}, labelProps, { variant: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.variant) ? "h4" : labelProps.variant }), label));
        }
        else {
            return label;
        }
    }
    function renderDescription(description) {
        if (typeof description === "string") {
            return React.createElement(YZTypography, { variant: "body1", color: "textSecondary" }, description);
        }
        else {
            return (React.createElement(React.Fragment, null, description.map(function (p) { return (React.createElement(Typography, __assign({ variant: "body1", color: "textSecondary" }, descriptionProps), p)); })));
        }
    }
};

var GenericLoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 75 : _b;
    return (React.createElement(Box, { width: "100%", display: "flex", justifyContent: "center", pt: 8 },
        React.createElement(CircularProgress, { size: size })));
};

var useStyles$d = makeStyles(function (theme) { return ({
    root: {
        height: function (props) { return props.pixelSize; },
        width: function (props) { return props.pixelSize; },
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: function (props) {
            return props.onClickBoolean ? "pointer" : undefined;
        },
    },
    textBox: {
        position: "absolute",
        display: "inline",
        fontSize: function (props) { return props.textSize; },
    },
}); });
var VIPIcon = function (_a) {
    var size = _a.size, onClick = _a.onClick;
    var pixelSize = size + "px";
    var textSize = size / 45 + "rem";
    var classes = useStyles$d({
        pixelSize: pixelSize,
        textSize: textSize,
        onClickBoolean: !!onClick,
    });
    return (React.createElement(Box, { className: classes.root, onClick: onClick },
        React.createElement(Star, { style: {
                height: pixelSize,
                width: pixelSize,
                color: "gold",
            } }),
        React.createElement(Typography, { className: classes.textBox, align: "center" }, "VIP")));
};

var useStyles$e = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    card: {
        height: "268px",
        width: "268px",
        backgroundColor: function (props) { return props.colorHex; },
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    label: {
        marginTop: "10px",
    },
    editLink: {
        marginTop: "4px",
        alignSelf: "flex-end",
        textDecoration: "underline",
        color: function (props) { return (props.isDark ? "white" : "black"); },
    },
    pointer: {
        cursor: "pointer",
    },
}); });
var PaintColorCard = function (_a) {
    var colorHex = _a.colorHex, isDark = _a.isDark, name = _a.name, variant = _a.variant, selectedPlacement = _a.selectedPlacement, placementOptions = _a.placementOptions, selectColor = _a.selectColor, removeColor = _a.removeColor;
    var classes = useStyles$e({ colorHex: colorHex, isDark: isDark });
    var _b = useState(false), selecting = _b[0], setSelecting = _b[1];
    var _c = useState(false), editing = _c[0], setEditing = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    return (React.createElement(Box, { className: classes.root, onClick: handleRootClick },
        variant === "DISPLAY" ? renderDisplayVariant() : renderSelectVariant(),
        React.createElement(YZTypography, { display: "inline", type: "mono", className: classes.label }, name),
        variant === "DISPLAY" && (React.createElement(YZTypography, { display: "inline", type: "mono", className: classes.label }, colorHex))));
    function renderDisplayVariant(editable) {
        if (editable === void 0) { editable = false; }
        return (React.createElement(Box, { className: classes.card },
            React.createElement(Box, { width: "75%", py: "4px", display: "flex", flexDirection: "column", alignItems: "center" },
                React.createElement(YZButton, { disabled: true, fullWidth: true, slim: true, style: { backgroundColor: "white", borderColor: "black" }, typographyProps: { style: { color: "black" } }, variant: "outlined" }, selectedPlacement),
                editable && (React.createElement(YZTypography, { variant: "body2", className: classnames(classes.editLink, classes.pointer), onClick: function () { return setEditing(true); } }, "edit")))));
    }
    function renderSelectVariant() {
        return (
        // Color square
        React.createElement(Box, { className: cardIsSelectable()
                ? classnames(classes.card, classes.pointer)
                : classes.card },
            saving && (React.createElement(YZTypography, { style: { color: isDark ? "white" : "black" }, type: "mono", align: "center" }, "saving...")),
            (selecting || editing) && !saving && (React.createElement(Box, { width: "75%", display: "flex", flexDirection: "column", alignItems: "center" }, placementOptions === null || placementOptions === void 0 ? void 0 :
                placementOptions.map(function (opt) { return (React.createElement(Box, { key: opt + "-key", py: "4px", width: "100%" },
                    React.createElement(YZButton, { fullWidth: true, slim: true, onClick: function () { return handleSelectColor(colorHex, opt); }, style: { backgroundColor: "white" }, variant: "outlined" }, opt))); }),
                selecting && (React.createElement(YZTypography, { variant: "body2", className: classnames(classes.editLink, classes.pointer), onClick: function () { return setSelecting(false); } }, "nevermind")),
                editing && (React.createElement(YZTypography, { variant: "body2", className: classnames(classes.editLink, classes.pointer), onClick: function () { return handleRemoveColor(colorHex); } }, "remove this color")))),
            selectedPlacement &&
                !selecting &&
                !editing &&
                renderDisplayVariant(true)));
    }
    function cardIsSelectable() {
        return variant === "SELECT" && !selecting && !editing && !selectedPlacement;
    }
    function handleRootClick() {
        if (cardIsSelectable()) {
            setSelecting(true);
        }
    }
    function handleSelectColor(colorHex, placement) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectColor) return [3 /*break*/, 2];
                        setSaving(true);
                        return [4 /*yield*/, selectColor(colorHex, placement)];
                    case 1:
                        _a.sent();
                        resetStatus();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function handleRemoveColor(colorHex) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!removeColor) return [3 /*break*/, 2];
                        setSaving(true);
                        return [4 /*yield*/, removeColor(colorHex)];
                    case 1:
                        _a.sent();
                        resetStatus();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function resetStatus() {
        setSelecting(false);
        setEditing(false);
        setSaving(false);
    }
};

/**
 * Component used to allow Yardzen clients to select paint colors for exterior design projects
 * @summary
 *    - on root click, `placementOptions` will be mapped and displayed
 *    - `selectColor` will be called on placement button click
 *    - once a placement is selected, pass the selected placement as `selectedPlacement`
 *    - press "edit" to display placement options again and see remove button
 *    - `selectColor` will be fired again when placement is selected
 *    - `removeColor` will be called when user clicks "remove this color"
 */
var PaintColorSelectCard = function (props) {
    return React.createElement(PaintColorCard, __assign({}, props, { variant: "SELECT" }));
};

/**
 * Component used to display paint color selections to Yardzen employees and contractors
 */
var PaintColorDisplayCard = function (props) {
    return React.createElement(PaintColorCard, __assign({}, props, { variant: "DISPLAY" }));
};

var useStyles$f = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        flexBasis: '80%',
        flexShrink: 0,
        display: "flex",
        alignItems: "center"
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        fontWeight: 800
    },
    noDataChip: {
        display: "flex",
        alignItems: "center",
        background: "#ededed",
        padding: "0.5rem",
        borderRadius: theme.typography.pxToRem(5)
    },
    noDataChipIcon: {
        color: "#f0dab8",
        marginRight: '0.2rem'
    },
    accordionDetails: {},
    mainGrid: {
        background: "#FAFAFA"
    },
    subHeading: {
        color: "#808080",
        textAlign: "right"
    },
    standoutText: {
        background: "#F2F2F2",
    },
    text: {}
}); });
function YZAccordion(props) {
    var classes = useStyles$f();
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var handleChange = function () {
        setExpanded(function () { return !expanded; });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { expanded: expanded, onChange: handleChange },
            React.createElement(AccordionSummary, { className: classes.accordionDetails, expandIcon: React.createElement(ExpandMoreIcon, null), "aria-controls": "panel1bh-content", id: "panel1bh-header" },
                React.createElement(YZTypography, { type: "serif", className: classes.heading }, props.title),
                props.chip),
            React.createElement(AccordionDetails, { className: classes.accordionDetails },
                React.createElement(Grid$1, { className: classes.mainGrid, container: true, spacing: 3 }, Array.from(Array(Math.max(props.contentLeft.length, props.contentRight.length))).map(function (_, it) { return (React.createElement(React.Fragment, { key: it },
                    React.createElement(Grid$1, { className: props.contentLeft[it].highlight ? classes.standoutText : classes.text, item: true, xs: 3 },
                        React.createElement(Typography, { className: classes.subHeading }, props.contentLeft[it].heading)),
                    React.createElement(Grid$1, { className: props.contentLeft[it].highlight ? classes.standoutText : classes.text, item: true, xs: 3 },
                        React.createElement(Typography, null, props.contentLeft[it].content)),
                    props.contentRight[it] ? (React.createElement(React.Fragment, null,
                        React.createElement(Grid$1, { className: props.contentRight[it].highlight ? classes.standoutText : classes.text, item: true, xs: 3 },
                            React.createElement(Typography, { className: classes.subHeading }, props.contentRight[it].heading)),
                        React.createElement(Grid$1, { className: props.contentRight[it].highlight ? classes.standoutText : classes.text, item: true, xs: 3 },
                            React.createElement(Typography, null, props.contentRight[it].content)))) : (React.createElement(React.Fragment, null,
                        React.createElement(Grid$1, { item: true, xs: 3 }),
                        React.createElement(Grid$1, { item: true, xs: 3 }))))); }))))));
}

var useStyles$g = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '80%',
        flexShrink: 0,
        display: "flex",
        alignItems: "center"
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(10.6),
        color: theme.palette.text.secondary,
        width: "max-content"
    },
    noDataChip: {
        display: "flex",
        alignItems: "center",
        background: "#F2F2F2",
        padding: theme.typography.pxToRem(8),
        borderRadius: theme.typography.pxToRem(4)
    },
    noDataChipIcon: {
        width: theme.typography.pxToRem(18),
        height: theme.typography.pxToRem(18),
        color: "#f0dab8",
        marginRight: '0.2rem'
    },
    successChipIcon: {
        width: theme.typography.pxToRem(18),
        height: theme.typography.pxToRem(18),
        color: "#8AA78A",
        marginRight: '0.2rem'
    }
}); });
function YZAccordionChip(props) {
    var classes = useStyles$g();
    return (React.createElement("div", { className: classes.noDataChip },
        React.createElement(CheckCircleIcon, { className: props.text === "SUCCESS" ? classes.successChipIcon : classes.noDataChipIcon }),
        React.createElement(YZTypography, { variant: "caption", className: classes.secondaryHeading }, props.text)));
}

var useStyles$h = makeStyles(function (theme) { return ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        flexBasis: "80%",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        fontWeight: 800,
    },
    noDataChip: {
        display: "flex",
        alignItems: "center",
        background: "#ededed",
        padding: "0.5rem",
        borderRadius: theme.typography.pxToRem(5),
    },
    noDataChipIcon: {
        color: "#f0dab8",
        marginRight: "0.2rem",
    },
    accordionDetails: {},
    mainGrid: {
        background: "#FAFAFA",
    },
    subHeading: {
        color: "#808080",
        textAlign: "right",
    },
    standoutText: {
        background: "#F2F2F2",
    },
    text: {},
    table: {
        minWidth: 650,
    },
    image: {
        maxHeight: "8rem",
    },
}); });
function YZItemsAccordion(props) {
    var classes = useStyles$h();
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var handleChange = function () {
        setExpanded(function () { return !expanded; });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { expanded: expanded, onChange: handleChange, disabled: props.loading },
            React.createElement(AccordionSummary, { className: classes.accordionDetails, expandIcon: props.loading ? React.createElement(CircularProgress, null) : React.createElement(ExpandMoreIcon, null), "aria-controls": "panel1bh-content", id: "panel1bh-header" },
                React.createElement(YZTypography, { type: "serif", className: classes.heading }, props.title),
                props.loading || props.chip),
            React.createElement(AccordionDetails, { className: classes.accordionDetails },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { size: "small", className: classes.table, "aria-label": "simple table" },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, null, props.fields.map(function (field, index) { return (React.createElement(TableCell, { key: field.header, align: index === 0 ? "inherit" : field.headerAlign || "right" }, field.header)); }))),
                        React.createElement(TableBody, null, props.rows.map(function (row) { return (React.createElement(TableRow, { key: row.id }, props.fields.map(function (field, _index) {
                            if (field.fieldName === "image") {
                                return (React.createElement(TableCell, { align: "right" },
                                    React.createElement("img", { className: classes.image, src: row[field.fieldName] })));
                            }
                            return (React.createElement(TableCell, { align: _index === 0 ? "inherit" : "right", component: "th", scope: "row" }, row[field.fieldName]));
                        }))); }))))))));
}

var useStyles$i = makeStyles(function (_a) {
    var _b, _c, _d, _e, _f;
    var breakpoints = _a.breakpoints, palette = _a.palette, spacing = _a.spacing;
    return ({
        root: (_b = {
                overflow: "hidden"
            },
            _b[breakpoints.down("xs")] = {
                alignItems: "flex-end",
                width: "100wv",
                padding: 0,
            },
            _b),
        dialogContent: (_c = {},
            _c[breakpoints.down("xs")] = {
                padding: 0,
                paddingBottom: "25px",
            },
            _c),
        paper: (_d = {
                borderRadius: 0
            },
            _d[breakpoints.down("xs")] = {
                width: "100%",
                borderRadius: "14px",
                position: "absolute",
                bottom: "-14px",
                marginBottom: 0,
                padding: 0,
            },
            _d),
        butttonContainer: (_e = {
                margin: spacing(2),
                marginTop: spacing(3)
            },
            _e[breakpoints.down("xs")] = {
                margin: 0,
            },
            _e),
        prompt: (_f = {
                textAlign: "center"
            },
            _f[breakpoints.up("sm")] = {
                textAlign: "left",
                paddingBottom: "0.5rem",
            },
            _f),
    });
});
var Prompt = function (props) {
    var classes = useStyles$i();
    var _a = useState(true), slideOpen = _a[0], setSlideOpen = _a[1];
    var _b = useState(true), backdropOpen = _b[0], setBackdropOpen = _b[1];
    var smDown = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    return (createElement(Dialog, { open: backdropOpen, classes: {
            root: classes.root,
            paper: classes.paper,
        }, onClose: function () { return setBackdropOpen(false); } },
        createElement(Slide, { timeout: smDown ? void 0 : -Infinity, direction: "up", in: slideOpen, mountOnEnter: true, unmountOnExit: true },
            createElement(DialogContent, { className: classes.dialogContent },
                createElement(DialogTitle, { style: { padding: 0 } },
                    createElement(YZTypography, { className: classes.prompt, variant: "h4", type: "serif" }, props.prompt)),
                props.promptDescription && (createElement(Box, { my: 1 },
                    createElement(YZTypography, { style: { textAlign: "left" }, color: "textSecondary" }, props.promptDescription))),
                createElement(Box, { className: classes.butttonContainer, display: "flex", width: "100%", justifyContent: "space-around" },
                    createElement(YZButton, { onClick: function () { return onSelect(false); }, slim: true }, "Cancel"),
                    createElement(YZButton, { onClick: function () { return onSelect(true); }, color: "primary", slim: true }, "Confirm"))))));
    function onSelect(response) {
        setSlideOpen(false);
        setTimeout(function () {
            setBackdropOpen(false);
            setTimeout(function () {
                props.onSelect(response);
            }, 250);
        }, 100);
    }
};

var useStyles$j = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, spacing = _a.spacing, palette = _a.palette;
    return ({
        root: (_b = {
                marginBottom: spacing(4)
            },
            _b[breakpoints.up("sm")] = {
                width: "75%",
            },
            _b[breakpoints.down("xs")] = {
                width: "100%",
                margin: spacing(3) + "px 0 " + spacing(3) + "px 0 ",
            },
            _b),
        removeButton: {
            background: "#fff",
            boxShadow: "0 8px 20px rgba(0,0,0,.05)",
            transition: "all ease-in 0.15s",
            "&:hover": {
                background: "#fff",
                transform: "translate(0, -2px)",
            },
        },
        deleteIcon: {
            color: palette.error.main,
            fontSize: 14.4,
        },
    });
});
var ProgressTracker = function (_a) {
    var title = _a.title, children = _a.children, removeOptions = _a.removeOptions;
    var classes = useStyles$j();
    var theme = useTheme$1();
    var _b = React.useState(false), confirmRemoveModalOpen = _b[0], setConfirmRemoveModalOpen = _b[1];
    var _c = React.useState(true), growIn = _c[0], setGrowIn = _c[1];
    function remove() {
        setGrowIn(false);
        setTimeout(removeOptions.onRemove, 250);
    }
    return (React.createElement(React.Fragment, null,
        removeOptions && confirmRemoveModalOpen && (React.createElement(Prompt, { prompt: removeOptions.promptTitle, promptDescription: removeOptions.promptBody, onSelect: function (removeConfirmed) {
                removeConfirmed && remove();
                setConfirmRemoveModalOpen(false);
            } })),
        React.createElement(Grow, { in: growIn },
            React.createElement(Box, { className: classes.root },
                React.createElement(Box, { display: "flex", alignItems: "center" },
                    React.createElement(Box, { flex: "1" },
                        React.createElement(YZTypography, { variant: "h5", type: "serif" }, title)),
                    removeOptions && (React.createElement(Tooltip, { title: removeOptions === null || removeOptions === void 0 ? void 0 : removeOptions.tooltipText, arrow: true },
                        React.createElement(IconButton, { onClick: function () { return setConfirmRemoveModalOpen(true); }, className: classes.removeButton },
                            React.createElement(Delete, { className: classes.deleteIcon }))))),
                React.createElement(List, null, children)))));
};

var useStyles$k = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        root: (_b = {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #E0E0E0",
                padding: "8px 12px",
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#fff",
                }
            },
            _b[breakpoints.down("sm")] = {},
            _b),
        completed: {
            background: "#DFE5DF",
            "&:hover": {
                backgroundColor: "#DFE5DF",
            },
        },
        optionalChip: {
            fontSize: 10,
            height: "1rem",
            marginLeft: 8,
            pointerEvents: "none",
        },
    });
});
function ProgressTrackerItem(_a) {
    var title = _a.title, completed = _a.completed, onClick = _a.onClick, description = _a.description, optional = _a.optional;
    var classes = useStyles$k();
    var icon = completed ? (React.createElement(CheckCircle, { color: "primary" })) : (React.createElement(RadioButtonUnchecked, { color: "primary" }));
    return (React.createElement(ListItem, { className: classnames([classes.root, completed && classes.completed]), onClick: onClick },
        React.createElement(Box, { display: "flex", alignItems: "center" },
            icon,
            React.createElement(Box, { ml: 2 },
                React.createElement(Typography, { variant: "subtitle1" },
                    title,
                    optional && (React.createElement(Chip, { size: "small", label: "Optional", variant: "outlined", className: classes.optionalChip }))),
                React.createElement(Typography, { color: "textSecondary", variant: "body2", style: { color: "#808080" } }, description))),
        React.createElement(ChevronRight, { style: { fontSize: 22 } })));
}

export { BudgetCategoryChecklistContainer, BudgetCategoryChecklistItem, CenterContentsForStorybook, ClientWishListProgressTracker, CostVersusBudgetInfo, DraggableItemWrapper, DroppableContainerWrapper, ExpansionFAQ, GenericLoadingSpinner, IconHeader, LabeledImageSelectItem, LabeledTextArea, MultipleImageSelectItemContainer, PaintColorDisplayCard, PaintColorSelectCard, PriceOptionSelectItem, ProgressTracker, ProgressTrackerItem, Prompt, StyleSelectItem, ToggleSelectButton, ToggleSelectWrapper, VIPIcon, YZAccordion, YZAccordionChip, YZAlert, YZButton, YZItemsAccordion, YZThemeProvider, YZTypography, formatNumToUSD, paletteOptions, parseExperienceVersion, passesExperienceVersionCheck, reExports as reactBeautifulDnd, theme, typographyOptions, useTriggerTimeout };
